import { toast } from "react-toastify";
/**
 * Exports the selected blueprint or the blueprintJSON into a text file
 * By default we will look in expObj.name for the name
 * @param {JSONObject} expObj - any JSON to be exported
 * @param {string} fileNameOverride - override the default naming for the exported file
 * @param {string} toastOverride - override the default toast message
 * @param {boolean} skipToast - do not show the toast message
 */
export function exportToFile(expObj, fileNameOverride, toastOverride, skipToast = false) {
    // If no objet was passed, noop
    if (!expObj) {
        return Promise.resolve();
    }
    // convert object to stringified JSON
    const retString = JSON.stringify(expObj);
    // Construct filename
    const fileName = `${fileNameOverride ?? expObj.name ?? "AibleExport"}.aible`;
    // Saving to text file with `.aible` extension
    const tempLink = document.createElement("a");
    const file = new Blob([retString], { type: "text/plain" });
    tempLink.href = URL.createObjectURL(file);
    tempLink.download = fileName;
    tempLink.click();
    URL.revokeObjectURL(tempLink.href);
    // toast notifying user export was successful
    const toastText = toastOverride ?? `${fileNameOverride ?? expObj.name ?? "File"} exported.`;
    if (!skipToast && toastText) {
        toast(toastText, {
            type: toast.TYPE.SUCCESS,
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3500
        });
    }
}
/**
 * Reads the text file and returns the obj that was stored in the file
 * @param {file} file - the text file that contains the stringified JSON we're converting back to an object
 * @param {boolean} skipToast - do not show the toast message
 * @returns {Promise<object>} promise resolves to the parsed object that was stored in the file
 */
export function importFromFile(file, skipToast = false) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                // if the file contains a string, parse it into an object
                const content = e.target?.result;
                if (typeof content === "string") {
                    const retObj = JSON.parse(content);
                    resolve(retObj);
                }
                else {
                    throw new Error("Unable to read data from file");
                }
            }
            catch (e) {
                // This error will occur when the JSON.parse fails or if the file doesn't have a string
                console.error(e);
                if (!skipToast) {
                    toast(`Invalid Import File. Please try again.`, {
                        type: toast.TYPE.ERROR,
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3500
                    });
                }
                reject(e);
            }
        };
        reader.onerror = (e) => {
            console.error("Error reading file:", e?.target?.error?.name);
            reject(e);
        };
        reader.readAsText(file);
    });
}
